let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VQh1")).then(() => parcelRequire('dwKA4'));